import axios, { AxiosInstance } from 'axios';
import { environment } from '../environment/environment';
import { clearSessionRecordingId, getRtcToken, getSessionRecordingId, setSessionRerdingId } from './storage.service';
import { StartRecordingResponse } from '../models/ISessionRecord';


export class SessionRecordService {
  private axiosInstance: AxiosInstance;
  private baseURL: string = environment.controlServerEndpoint
    private token: string | null | undefined;
  constructor() {
    this.token = getRtcToken();
  

    this.axiosInstance = axios.create({
      baseURL: this.baseURL,
      headers: {
        Authorization: `Bearer ${this.token}`,
        tenantAlias:  environment.tenantAlias
      }
    });
  }

  public async startRecording(sessionId: string): Promise<string> {
    const url = `/session/${sessionId}/recording/start`;

    try {
      const response = await this.axiosInstance.post<StartRecordingResponse>(url);
      const recordingId = response.data.recordingId;
      setSessionRerdingId(recordingId) 
      return recordingId;
    } catch (error) {
      console.error('Error starting recording:', error);
      throw error;
    }
  }

  public async stopRecording(sessionId: string): Promise<void> {
    const recordingId = getSessionRecordingId();
    if (!recordingId) {
      throw new Error('RecordingId not found in session storage');
    }

    const url = `/session/${sessionId}/recording/${recordingId}/stop`;

    try {
      await this.axiosInstance.post(url);
      clearSessionRecordingId()// Clear recordingId from session storage after stopping
    } catch (error) {
      console.error('Error stopping recording:', error);
      throw error;
    }
  }
}
